import {useIntl} from 'react-intl';
import {MonitorSmartphone, ShieldAlert} from 'lucide-react';
import type {CallBlock} from '../../groupCalls/services/groupCallOrchestrator';
import {groupCallService} from '../../groupCalls/services/groupCallService';
import {callsMessages as m} from './callsMessages';

export const CallBlockCard = ({block, className = ''}: {block: CallBlock; className?: string}) => {
    const intl = useIntl();
    const noE2ee = block.kind === 'no_e2ee';
    const Icon = noE2ee ? ShieldAlert : MonitorSmartphone;
    return (
        <div
            role="alert"
            data-testid="call-block-card"
            data-kind={block.kind}
            className={`phq-call-light flex gap-3 rounded-2xl bg-[var(--phq-call-surface)] p-4 text-[var(--phq-call-ink)] shadow-[0_16px_48px_rgba(0,0,0,.14),inset_0_0_0_1px_var(--phq-call-line)] ${className}`}
        >
            <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[var(--phq-call-danger-tint)] text-[var(--phq-call-danger)]">
                <Icon size={20} aria-hidden="true"/>
            </span>
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                <p className="text-[15px] font-semibold">{intl.formatMessage(noE2ee ? m.noE2eeTitle : m.otherDeviceTitle)}</p>
                <p className="text-sm leading-[1.45] text-[var(--phq-call-ink-strong-muted)]">{intl.formatMessage(noE2ee ? m.noE2eeBody : m.otherDeviceBody)}</p>
                <div className="mt-1.5 flex flex-wrap gap-2">
                    <button
                        type="button"
                        data-testid="call-block-dismiss"
                        onClick={() => groupCallService.dismissBlock()}
                        className="phq-call-press inline-flex h-9 items-center rounded-[10px] bg-[var(--phq-call-surface-muted)] px-3.5 text-sm font-semibold"
                    >
                        {intl.formatMessage(m.dismiss)}
                    </button>
                </div>
            </div>
        </div>
    );
};
